import vademecum from "../../../services/asegurator/asegurator-medicine";

import i18n from "../../../i18n/index";

export default {
    data() {
        return {
            search: "",
            headers: [{
                    text: "Plu",
                    sortable: true,
                    value: "pluCode",
                },
                {
                    text: "Principio activo",
                    sortable: true,
                    value: "ActiveIngredient",
                },
                {
                    text: "Descripción principio activo",
                    sortable: true,
                    value: "descriptionActiveIngredient",
                },
                {
                    text: "Nombre comercial",
                    sortable: false,
                    value: "nameTrade",
                },
                {
                    text: "Cantidad",
                    sortable: false,
                    value: "quantity",
                },
                {
                    text: "¿Aplicable?",
                    sortable: false,
                    value: "isApplicable",
                },
                {
                    text: "¿Regulado?",
                    sortable: false,
                    value: "isRegulated",
                },
                {
                    text: "Proveedor",
                    sortable: true,
                    value: "provider",
                },
                {
                    text: "Estado",
                    sortable: false,
                    value: "active",
                },
            ],

            itemsData: [],
            nroRows: 0,
        };
    },
    props: {},
    watch: {},
    mounted() {
        this.searchCity();
    },
    methods: {
        onRowClick(item) {
            this.$emit("row-click", item);
        },
        searchCity() {
            vademecum.getVademecumOrder().then((response) => {
                this.itemsData = response.data;
                this.nroRows = response.data.length;
            });
        },
        getLenght() {
            console.log(this.nroRows);
            return this.nroRows;
        },
        customFilter(items, search, filter) {
            search = search.toString().toLowerCase();
            return items.filter((row) => filter(row["ActiveIngredient"], search));
        },
    },
};